import { Divider } from '@mui/material';
import FormField from 'further-ui/components/FormField';
import NumberInput from 'further-ui/components/NumberInput';
import StaticField from 'further-ui/components/StaticField';
import { investment as rules } from 'further-ui/validations';
import { Controller, useFormContext } from 'react-hook-form';
import useHoldingClasses from '../hooks/useHoldingClasses';
type HoldingClassInfoFormProps = {
  index: number;
};

const HoldingClassInfoForm: React.FC<HoldingClassInfoFormProps> = ({
  index,
}) => {
  const { getValues, control, setValue, watch, setError } =
    useFormContext<rules.CreateInvestmentFormValues>();
  const { calculateUnitPrice } = useHoldingClasses({
    control,
    getValues,
    setValue,
    watch,
    setError,
  });
  const className = getValues(`holdingClasses.${index}.name`);
  const currency = getValues(`holdingClasses.${index}.currency`);

  return (
    <>
      <StaticField label="Class name" size="md" spacing="xs">
        {className}
      </StaticField>
      <FormField label="Investment amount" size="md">
        <Controller
          name={`holdingClasses.${index}.investmentAmountTcy`}
          control={control}
          render={({
            fieldState: { error },
            field: { ref, onChange, ...rest },
          }) => (
            <NumberInput
              fullWidth
              {...rest}
              onChange={(value) => {
                onChange(value);
                calculateUnitPrice(index);
              }}
              decimals={5}
              error={!!error}
              currency={currency}
              helperText={error?.message?.toString()}
              placeholder="Enter investment amount"
            />
          )}
        />
      </FormField>
      <FormField
        label="Number of units"
        tooltip="Add an estimated number of units if the actual number of units is unknown at the point of processing. This transaction can be edited after submission to include the actual number of units."
        size="md"
      >
        <Controller
          name={`holdingClasses.${index}.numberOfUnits`}
          control={control}
          render={({
            fieldState: { error },
            field: { ref, onChange, ...rest },
          }) => (
            <NumberInput
              fullWidth
              {...rest}
              onChange={(value) => {
                onChange(value);
                calculateUnitPrice(index);
              }}
              decimals={5}
              error={!!error}
              helperText={error?.message?.toString()}
              placeholder="Enter number of units"
            />
          )}
        />
      </FormField>
      <FormField label="Unit price" size="md">
        <Controller
          name={`holdingClasses.${index}.unitPriceTcy`}
          control={control}
          render={({
            fieldState: { error },
            field: { ref, onChange, ...rest },
          }) => (
            <NumberInput
              fullWidth
              {...rest}
              currency={currency}
              decimals={10}
              error={!!error}
              helperText={error?.message?.toString()}
              placeholder="Enter unit price"
            />
          )}
        />
      </FormField>
      <Divider />
    </>
  );
};

export default HoldingClassInfoForm;
